type OtherAttributesType = Record<string, any>;

export enum ConfigEntryFieldType {
  TEXT = 'TEXT',
  TEXTAREA = 'TEXTAREA',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  CHECKBOX = 'CHECKBOX',
  RADIO = 'RADIO',
  SELECT = 'SELECT',
  MULTI_SELECT = 'MULTI_SELECT',
  REGEX = 'REGEX',
  RATING = 'RATING',
  // Locally added for now. Once BE supports these standard field types. Remove this comment.
  EDITOR = 'EDITOR',
  ATTACHMENTS = 'ATTACHMENTS',
}

export enum ConfigEntryRefFuncName {
  INSIGHTS_DATE = 'insights_date',
  INSIGHTS_TYPES = 'insights_type',
}

export enum ConfigFieldEntryType {
  STANDARD = 'STANDARD',
  APPLICATION = 'APPLICATION',
  CUSTOM = 'CUSTOM',
}

export type ConfigEntryFeatureType = {
  displayName: string;
  name: string;
  isActive: boolean;
  roles?: string[];
};

export type ConfigEntryType = {
  configEntryRefMap?: Record<string, any>;
  deleteFlag?: boolean;
  entryCode: string;
  entryName?: string;
  entryDescription: string;
  entryType?: ConfigFieldEntryType;
  entryValues: string[];
  id?: string;
  isActive: boolean;
  modifiedAt?: Date | string;
  otherAttributes?: OtherAttributesType;
  referenceObject?: {
    configRefName?: string;
    freeText?: boolean;
    functionName?: ConfigEntryRefFuncName;
    label?: string;
    placeHolder?: string;
    type?: ConfigEntryFieldType;
    maxRating?: number;
    isRequired?: boolean;
    groupBy?: {
      isActive?: boolean;
      configRefName?: string;
    };
    filterBy?: {
      isActive?: boolean;
      configRefName?: string;
    };
    filterNameByLevels?: string[];
    groupEntryBy?: string;
    totalLevels?: number;
    roles?: string[];
    features?: ConfigEntryFeatureType[];
  };
  targetMapperJavaScriptFunction?: string;
  targetMapper?: string;
  targetMapperLabelName?: string;
  targetMapperType?: 'API' | 'CONFIG';
  targetMapperValueKey?: string;
  answers?: (string | number | boolean)[];
};

export enum FORMS_CONFIG_CATEGORY_TYPES {
  PROJECT_PROGRESS_CARD = 'PROJECT_PROGRESS_CARD',
  PROJECT_RETROSPECTIVE_CARD = 'PROJECT_RETROSPECTIVE_CARD',
  SCORECARD = 'SCORECARD',
  BUILDWISE_SCORECARD = 'BUILDWISE_SCORECARD',
  REQUEST_A_POST_CARD = 'REQUEST_A_POST_CARD',
}

export type ConfigType = {
  isActive?: boolean;
  companyId: string;
  configCategory?: FORMS_CONFIG_CATEGORY_TYPES;
  configCategoryDescription?: string;
  configName: string;
  configType?: string;
  createdAt?: string | Date;
  createdBy?: string;
  createdByDisplayName?: string;
  createdByExpYears?: string;
  createdByTitle?: string;
  customFields?: {
    [fieldName: string]: {
      fieldName: string;
      fieldValue: string | string[];
    };
  }[];
  description: string;
  entries: ConfigEntryType[];
  id: string;
  sortFlag?: boolean;
  title?: string;
  updatedAt?: string | Date;
  updatedBy?: string;
  updatedByDisplayName?: string;
  updatedByExpYears?: string;
  updatedByTitle?: string;
};

export type ConfigResponse = {
  config: ConfigType;
};
